import useTeams from '@hooks/useTeams';
import { Box, CircularProgress, Grid2 as Grid, Typography } from '@mui/material';
import FormInputMoney from '@components/forms/FormInputMoney';
import FormInputText from '@components/forms/FormInputText';
import FormImageUpload from '@components/forms/FormImageUpload';
import CodeOfConductForm from '@components/teamCreation/CodeOfConductForm';
import SubmitGeneralTeamInfoFAB from './SubmitGeneralTeamInfoFAB';

export default function TeamGeneralSettings() {
    const { loading, selectedTeam } = useTeams();

    return (
        <Box padding={2}>
            {loading ? (
                <Grid marginX={'50%'} paddingY={'20%'}>
                    <CircularProgress color="secondary" size={40} />
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    <FormImageUpload
                        fieldName="imageUrl"
                        description="Team Logo"
                        fileDisplayName={`${selectedTeam?.name} Team Logo`}
                        presetType={'team-image'}
                        uploadTags={selectedTeam?.name ? [selectedTeam?.name] : []}
                    />
                    <Grid size={3}>
                        <FormInputText name="name" label="Team Name" />
                    </Grid>
                    <Grid size={3}>
                        <FormInputMoney name="fee" label="Team Joining Fee" />
                    </Grid>
                    {/* 
                    <Grid size={6}>
                        <FormInputText name="description" label="Description" />
                    </Grid> */}

                    <Grid size={12}>
                        <Typography variant="h6" gutterBottom>
                            Code of Conduct
                        </Typography>

                        <CodeOfConductForm />
                    </Grid>

                    <SubmitGeneralTeamInfoFAB />
                </Grid>
            )}
        </Box>
    );
}
